import {BaseLinkProps, CtaDropdownProps} from 'epic-games-nav/dist/client';
import epicTracking from 'epic-tracking';
import history from 'history';
import root from 'window-or-global';

import LoginActions from '../../actions/LoginActions';
import {samsungStore} from '../../constants/PlatformUrls';
import {generateMainSitePath} from '../../utils/FortniteUtils';
import {isSamsung} from '../../utils/PlatformUtils';

import {NavMobileStore} from './nav.types';
import {routeMainSitePath, shouldUseClientSideRoute, trackNavigationClick} from './nav.utils';

export function setCTA(
  callToAction: BaseLinkProps,
  history: history.History,
  location: history.Location,
  mobile: NavMobileStore,
  isLoggedIn: boolean
): BaseLinkProps {
  const {userAgent} = root.navigator;
  const {androidDownloadData = {}} = mobile;
  const mobileSamsungLink =
    androidDownloadData && androidDownloadData.samsung && androidDownloadData.samsung.samsungLink
      ? androidDownloadData.samsung && androidDownloadData.samsung.samsungLink
      : samsungStore;

  if (shouldUseClientSideRoute(callToAction, location.pathname) || callToAction.useCustomCallback) {
    /**
     * Removed "iosLink" from the destructured props below, as it was an
     * outdated apple app store link. "iosEnabled" was a boolean value
     * that does not seem to be set after it's initial definition, so is
     * always false, meaning the if (ios) condition below would never run.
     */
    const {android, ios} = mobile;
    const href = isLoggedIn ? generateMainSitePath('success') : generateMainSitePath('download');

    const onClick = (e) => {
      e.preventDefault();
      trackNavigationClick('download');
      if (
        ios ||
        /iPad/.test(navigator.userAgent) ||
        (navigator.userAgent === 'MacIntel' && navigator.maxTouchPoints > 1)
      ) {
        /**
         * The second condition after the || is checking that the userAgent is
         * matched to an iPad device and clicking the PC button will
         * redirect to show to the user "Not available to download on ios devices"
         * */

        /**
         * Since the android condition uses this same function for the android
         * download page, and the "iosLink" was incorrect anyway, it seems fair
         * to go directly to the correct download page for iOS in this manner.
         */
        routeMainSitePath(history, location, 'download');
      } else if (
        android &&
        isSamsung(userAgent) &&
        !androidDownloadData?.samsung?.redirectToStore
      ) {
        // handle redirect to galaxy store for samsung devices without redirect flashing
        epicTracking.trackEvent('Interaction', {
          interactionType: 'redirect',
          eventCategory: 'fortnite Samsung',
          eventAction: 'Samsung download redirect',
          eventLabel: 'samsungRedirect',
        });

        root.location.href = mobileSamsungLink;
      } else if (android) {
        // using generateMainSitePath instead of routeMainSitePath
        // as this function was causing a blank screen to appear
        const goAndroid = generateMainSitePath('/mobile/android');
        root.location.href = goAndroid;
      } else {
        LoginActions.requestDownloadModal({redirectUrl: 'download'});
      }
    };
    return {
      title: callToAction.title,
      href,
      onClick,
    };
  }
  return callToAction;
}

export function setCtaDropdown(
  callToActionDropdown: CtaDropdownProps,
  history: history.History,
  location: history.Location,
  mobile: NavMobileStore,
  isLoggedIn: boolean
): CtaDropdownProps {
  const initCtaDropdownLinks = callToActionDropdown.links || [];
  if (!mobile?.mobile && !mobile?.tablet) {
    callToActionDropdown.disabled = true;
  }

  const callToActionDropdownLinks: BaseLinkProps[] = [];
  initCtaDropdownLinks.forEach((link) => {
    if (link.key === 'download') {
      callToActionDropdownLinks.push(setCTA(link, history, location, mobile || {}, isLoggedIn));
    }

    if (link.key === 'xcloud' || link.key === 'gfn') {
      callToActionDropdownLinks.push({
        ...link,
        onClick: (e) => {
          epicTracking.trackEvent('Interaction', {
            eventCategory: 'fn-web',
            eventAction: 'fn-nav',
            eventLabel: `${link.key}_streaming`,
            eventValue: link.href,
            interactionType: 'click',
          });
        },
      });
    }
  });
  callToActionDropdown.links = callToActionDropdownLinks;

  return callToActionDropdown;
}
